var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-table-wrapper"},[_c('div',{staticClass:"c-table"},[_c(_setup.HeaderDeAdiantamentos,{attrs:{"dado":_vm.dado,"parcela":_vm.parcela}}),_c(_setup.BodyDeAdiantamentos,{attrs:{"dado":_vm.dado,"parcela":_vm.parcela},on:{"update:alteraAdiantamento":_setup.alteraAdiantamento}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }